import { render, staticRenderFns } from "./PayedDetail.vue?vue&type=template&id=04287ba4&scoped=true&"
import script from "./PayedDetail.vue?vue&type=script&lang=js&"
export * from "./PayedDetail.vue?vue&type=script&lang=js&"
import style0 from "./PayedDetail.vue?vue&type=style&index=0&id=04287ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04287ba4",
  null
  
)

export default component.exports